import * as api from 'Shared/api';
import { handleError, showNotificationError } from 'Shared/helpers';
import { EventTypes } from 'redux-segment';

import * as OrganizationAPI from '../api/Organization.api';

import WpToastManager from 'Wpds/components/toast/WpToastManager';
import { updateOrganization, getBillingData } from 'Shared/api/organization';

export const extendTrialSuccess = () => ({
  type: 'organizations/EXTEND_TRIAL_SUCCESS',
});

export const updateSalesforceUserTags = ({ tags, userId }) => dispatch =>
  api.updateSalesforceUserTags({ tags, userId }).then(
    response => {
      dispatch({
        type: 'UPDATE_SALESFORCE_USER_TAGS_RESPONSE',
        payload: response.data,
      });
    },
    error => {
      dispatch(handleError(error));
    }
  );

export const updateSalesforceUserLinks = links => dispatch =>
  api.updateSalesforceUserLinks(links).then(
    response => {
      dispatch({
        type: 'UPDATE_SALESFORCE_USER_LINKS_RESPONSE',
        payload: response.data,
      });
      WpToastManager.success('Settings saved.');
    },
    error => {
      dispatch(handleError(error));
    }
  );

export const updateRecommendationNotificationSettings = settings_updates => dispatch =>
  api.updateRecommendationNotificationSettings(settings_updates).then(
    response => {
      dispatch({
        type: 'UPDATE_RECOMMENDATION_NOTIFICATION_SETTINGS_RESPONSE',
        payload: response.data,
        meta: {
          analytics: {
            eventType: EventTypes.track,
            eventPayload: {
              event: 'Changed NudgeBot Notification Settings',
              properties: { settings_updates },
            },
          },
        },
      });
      WpToastManager.success('Settings saved.');
    },
    error => {
      dispatch(handleError(error));
    }
  );

export const getSalesforceUsers = () => dispatch =>
  api.getSalesforceUsers().then(
    response => {
      dispatch({
        type: 'GET_SALESFORCE_USERS_RESPONSE',
        payload: response.data,
      });
    },
    error => {
      dispatch(handleError(error));
    }
  );

export const getRecommendationSettings = () => dispatch =>
  api.getRecommendationSettings().then(
    response => {
      dispatch({
        type: 'GET_RECOMMENDATION_SETTINGS_RESPONSE',
        payload: response.data,
      });
    },
    error => {
      dispatch(handleError(error));
    }
  );

export const getRecommendationNotificationSettings = () => dispatch =>
  api.getRecommendationNotificationSettings().then(
    response => {
      dispatch({
        type: 'GET_RECOMMENDATION_NOTIFICATION_SETTINGS_RESPONSE',
        payload: response.data,
      });
    },
    error => {
      dispatch(handleError(error));
    }
  );

export const updateRecommendationSettings = settings_updates => dispatch =>
  api.updateRecommendationSettings(settings_updates).then(
    response => {
      const isActive = settings_updates ? Object.values(settings_updates)[0].active : false;

      dispatch({
        type: 'UPDATE_RECOMMENDATION_SETTINGS_RESPONSE',
        payload: response.data,
        meta: {
          analytics: {
            eventType: EventTypes.track,
            eventPayload: {
              event: 'Changed NudgeBot Settings',
              properties: { isActive, settings_updates },
            },
          },
        },
      });
      WpToastManager.success('Settings saved.');
    },
    error => {
      dispatch(handleError(error));
    }
  );

export const toggleRecommendation = ({ recommendationKlassName }) => dispatch =>
  api.toggleRecommendation({ recommendationKlassName }).then(
    response => {
      dispatch({
        type: 'RECOMMENDATION_TOGGLE_ACTIVE_RESPONSE',
        payload: {
          recommendationKlassName: response.data.recommendationKlassName,
          value: response.data.value,
        },
      });
      WpToastManager.success('Settings saved');
    },
    error => {
      dispatch(handleError(error));
    }
  );

export const getRecommendationPreviews = (recommendation_klass_name, settings) => dispatch => {
  const request_id = Math.floor(Math.random() * 100000).toString();

  dispatch({
    type: 'RECOMMENDATION_PREVIEWS_GET_REQUEST',
    payload: { request_id },
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: 'Viewed Nudgebot Previews',
          properties: { recommendation_klass_name },
        },
      },
    },
  });

  return api
    .getRecommendationPreviews({
      recommendation_klass_name,
      request_id,
      settings,
    })
    .then(
      response => {
        dispatch({
          type: 'RECOMMENDATION_PREVIEWS_GET_REQUEST_ID_RESPONSE',
          payload: response.data,
        });
      },
      error => {
        dispatch(handleError(error));
      }
    );
};

export const getRecommendationAnalytics = ({ userId, tags }) => dispatch => {
  dispatch({ type: 'RECOMMENDATION_ANALYTICS_REQUEST', payload: null, userId });

  return api.getRecommendationAnalytics({ userId, tags }).then(
    response => {
      dispatch({
        type: 'RECOMMENDATION_ANALYTICS_RESPONSE',
        payload: response.data,
        userId,
      });
    },
    error => {
      dispatch(handleError(error));
    }
  );
};

export const updateOrganizationAction = params => async (dispatch, getState) => {
  const { id, name, availableDomains } = params;
  const { organization } = getState();
  const updatedOrganization = { ...organization, ...params };
  dispatch({ type: 'UPDATE_ORGANIZATION_REQUEST', payload: { organization: updatedOrganization } });
  try {
    const response = await updateOrganization({ id, name, domains_that_can_join: availableDomains });
    if (response && response.status === 200) {
      WpToastManager.success('Organization was updated!');
    } else {
      dispatch({ type: 'UPDATE_ORGANIZATION_ERROR', payload: { organization } });
    }
  } catch (e) {
    showNotificationError(e);
    dispatch({ type: 'UPDATE_ORGANIZATION_ERROR', payload: { organization } });
  }
};

export const getBillingDataAction = () => async dispatch => {
  const response = await getBillingData();
  if (response && response.status === 200) {
    dispatch({
      type: 'UPDATE_ORGANIZATION_RESPONSE',
      payload: {
        organization: { billingState: response.data.billingState, seatsToBillFor: response.data.seatsToBillFor },
      },
    });
  }
};

export const extendTrial = () => dispatch => {
  return OrganizationAPI.extendTrial()
    .then(response => {
      dispatch(extendTrialSuccess());
      return response.data;
    })
    .catch(error => {
      showNotificationError(error);
    });
};
